import {
    apiRequest,
    riwayatGajiDetail
} from "../../../../../services/adapters/kepegawaian/riwayatGajiService"

class DetailRepository {

    fetchDetail = async (query) => {
        return await apiRequest("get", riwayatGajiDetail, {
            params: query
        }, true)
    }
}

export default DetailRepository